<form [formGroup]="loanDetails" id="loan-details" (ngSubmit)=onSubmit(loanDetails)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container"
		[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
			(editQuestionChange)="editQuestionChange($event)">
			<question [qID]="'1'">
				<h1>{{'LOAN_DETAILS.Q1.QUESTION'|translate }}</h1>
				<div class="mt-4">
					<box-selector formControlName="loanPurpose" [options]="optionsPurpose"
						[(selectedOption)]="selectedOptionPurpose" (optionClicked)="onSubmit(loanDetails)">
					</box-selector>
				</div>
			</question>
			<question [qID]="'1.1'">
				<div>
					<div class="mb-4 text-md-right text-center">
						<h3 class="app-title-xxxlarge-blue">{{'LOAN_DETAILS.Q1_1.QUESTION'|translate}}</h3>
					</div>
					<div class="row justify-content-center justify-content-md-start form-group">
						<div class="col-lg-3 col-md-4 col-sm-6 col-12 mt-2">
							<!-- <input formControlName="loanPurposeDetails" class="app-input" type="text" value="" onchange="setAttribute('value', this.value)">
							<label class="label">{{'LOAN_DETAILS.Q1_1.LOAN_PURPOSE'|translate}}</label> -->
							<app-animated-input formControlName="loanPurposeDetails"
								placeholder="{{'LOAN_DETAILS.Q1_1.LOAN_PURPOSE'|translate}}" [animatedLabel]="true">
							</app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('loanPurposeDetails').hasError('required') && submitted">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('loanPurposeDetails').hasError('pattern') && submitted">{{
								'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid, 'button-primary-disabled': !(loanDetails.valid && qID=='1.1')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<question [qID]="'2'">
				<div>
					<div class="mb-4 text-md-right text-center mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q2.QUESTION"|translate}}</h1>
					</div>
					<div class="row justify-content-center justify-content-md-start form-group">
						<div class="col-lg-3 col-md-4 col-sm-6 col-12 input-wrapper">
							<app-animated-input formControlName="howMuchYouNeed" [type]="'tel'"
								placeholder="{{'LOAN_DETAILS.Q2.PH1'|translate}}" [hasCurrencyMask]="true"
								[animatedLabel]="true" [attAriaLabel]="'LOAN_DETAILS.Q2.PH1'|translate" #howMuchYouNeed>
							</app-animated-input>	

							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('howMuchYouNeed').hasError('required') && submitted"
								role="alert">{{
								'COMMON.FIELD_REQUIRED'
								| translate }}</label>

							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('howMuchYouNeed').hasError('min') && submitted" role="alert">{{
								'LOAN_DETAILS.Q2.MIN_ERROR'
								| translate }}</label>								
						</div>
					</div>
					<div class="mb-4 text-md-right text-center mt-md-0 mt-5">
						{{'LOAN_DETAILS.Q2.msg'| translate }}
					</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid , 'button-primary-disabled': !(loanDetails.valid && qID=='2')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<question [qID]="'2.0'">
				<div class="text-md-right text-center mb-3 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q2_3.QUESTION"|translate}}</h1>
					<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_3.msg1"|translate}}</h3>
					<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_3.msg3"|translate}}
						<a (click)="openWebSite(1)" class="app-link c-drak app-text-decoration app-title-small-bold">
							{{'LOAN_DETAILS.Q2_3.msg4' |translate}}</a>
					</h3>
					<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_3.msg2"|translate}}</h3>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
					data-toggle="buttons">
					<div class="section py-5">
						<input type="radio" class="app-input" formControlName="zakaut" id="yesRadio" checked
							[value]="'YES'">
						<label for="yesRadio" tabindex="0" data-id="yesRadioLabel">{{"COMMON.YES"|translate}}</label>

						<input type="radio" class="app-input" formControlName="zakaut" id="noRadio" [value]="'NO'">
						<label class="mr-5" for="noRadio" tabindex="0"
							data-id="noRadioLabel">{{"COMMON.NO"|translate}}</label>
					</div>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
						*ngIf="loanDetails.get('zakaut').hasError('required') && submitted" role="alert">{{
						'COMMON.FIELD_REQUIRED'
						| translate }}</label>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid, 'button-primary-disabled': !(loanDetails.valid && qID=='2.0')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<question [qID]="'2.1'">
				<div>
					<div class="text-md-right text-center mb-3 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q2_4.QUESTION"|translate}}</h1>
						<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_4.msg1"|translate}}</h3>
						<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_4.msg2"|translate}}</h3>
						<h3 class="app-title-small-bold">{{"LOAN_DETAILS.Q2_4.msg3"|translate}}
							<a (click)="openWebSite(2)"
								class="app-link c-drak app-text-decoration app-title-small-bold">
								{{'LOAN_DETAILS.Q2_4.msg4' |translate}}</a>
						</h3>
					</div>
					<div class="row justify-content-center justify-content-md-start form-group">
						<div class="col-lg-3 col-md-4 col-sm-6 col-12 input-wrapper">
							<app-animated-input formControlName="scumZakaut" [type]="'tel'" [hasCurrencyMask]="true"
								[animatedLabel]="true" #scumZakaut></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('scumZakaut').hasError('required') && submitted" role="alert">{{
								'COMMON.FIELD_REQUIRED'
								| translate }}</label>
							<div class="form-text m-error"
								*ngIf="loanDetails.get('scumZakaut').hasError('scumZakautError1') && submitted">
								{{ 'LOAN_DETAILS.Q2_4.error1' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="loanDetails.get('scumZakaut').hasError('scumZakautError2') && submitted">
								{{ 'LOAN_DETAILS.Q2_4.error2' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="loanDetails.get('scumZakaut').hasError('scumZakautError3') && submitted">
								{{ 'LOAN_DETAILS.Q2_4.error3' | translate }}
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid, 'button-primary-disabled': !(loanDetails.valid && qID=='2.1')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<question [qID]="'2.2'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue text-lg-right">{{"LOAN_DETAILS.Q2_2.QUESTION"|translate}}</h1>
					<inner-tooltip [qTitle]="'LOAN_DETAILS.Q2_2.tooltip'|translate"
						[text]="'LOAN_DETAILS.Q2_2.tooltip-msg'|translate" class="m-start-tooltip app-title-small-blue">
					</inner-tooltip>
					<div class="row  form-row justify-content-md-start justify-content-center">
						<div class="form-group col-12 col-md-4 col-md-4 input-wrapper pr-0 w-100 mt-3">
							<app-dplist-new [valueArr]='numberYears' formControlName="tkufa"
								[disabled]="loanDetails.get('tkufa').disabled" [asyncData]="false"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('tkufa').hasError('required') && submitted" role="alert">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-md-5 mt-4">
						<button type="submit" class="app-button"
							[ngClass]="{'button-primary': loanDetails.valid && qID=='2.2', 'button-primary-disabled': !(loanDetails.valid && qID=='2.2')}">{{"BORROWERS_DETAILS.QUESTION1.BUTTON"|translate}}</button>

					</div>
				</div>
			</question>

			<!--mixture-advisor -->
			<question [qID]="'2.4'">
				<h1 class="app-title-xxxlarge-blue">{{'LOAN_DETAILS.Q8.QUESTION'|translate}}</h1>
				<div class="col-12 mt-2 mr-2">
					<div *ngIf="loanDetails.get('loanPurpose').value!=='11'" class="section py-5">
						<input type="radio" class="app-input" formControlName="herkevGeneri" id="appRadio"
							[value]="'1'">
						<label class="mr-5" for="appRadio" tabindex="0"
							data-id="appRadioLabel">{{'LOAN_DETAILS.Q8.OPTION1'|translate}}</label>

						<input type="radio" class="app-input" formControlName="herkevGeneri" id="herkevGeneriRadio"
							[value]="'2'">
						<label class="mr-5" for="herkevGeneriRadio" tabindex="0"
							data-id="herkevGeneriRadioLabel">{{'LOAN_DETAILS.Q8.OPTION2'|translate}}</label>
						<div class="app-title-mini-blue-bold" *ngIf="loanDetails.get('herkevGeneri').value==='1'">
							{{'LOAN_DETAILS.Q8.TEXT_HERKEV_GENERI'|translate}}
						</div>
					</div>
				</div>

				<div *ngIf="loanDetails.get('herkevGeneri').value!=='1'" class="mx-1 form-group">
					<app-mixture (onAddFormGroup)="setValidatorsArray()" (onFormChange)="setValidatorsArray()"
						[displayErrors]="submitted" [mixtureFormArray]="loanDetails.get('Mixture')">
					</app-mixture>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid, 'button-primary-disabled': !(loanDetails.valid && qID=='2.4')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				<div class="form-text m-error"
					*ngIf="loanDetails.get('zakaut').value==='NO' && loanDetails.get('herkevGeneri').value!=='1' && loanDetails.get('Mixture').hasError('amountNotEquelMash') && submitted">
					{{ 'LOAN_DETAILS.Q8.ERROR_MESSAGE' | translate }}
				</div>
				<div class="form-text m-error"
					*ngIf="loanDetails.get('zakaut').value==='YES' && loanDetails.get('herkevGeneri').value!=='1' && loanDetails.get('Mixture').hasError('amountNotEquelMashWithZakaut') && submitted">
					{{ 'LOAN_DETAILS.Q8.ERROR_MESSAGE2' | translate }}
				</div>							
				<div class="form-text m-error"
				*ngIf="loanDetails.get('herkevGeneri').value!=='1'
				  && loanDetails.get('Mixture').hasError('periodMismatch')
				  && submitted">
			 		{{ 'LOAN_DETAILS.Q8.ERROR_TKUFA_MISMATCH' | translate }}
		   		</div>	
				<div class="form-text m-error"
				   *ngIf="loanDetails.get('herkevGeneri').value!=='1'
			 		&& loanDetails.get('Mixture').hasError('fixedThirdMissing')
			 		&& submitted">
				  {{ 'LOAN_DETAILS.Q8.ERROR_FIXED_MIN_THIRD' | translate }}
			  </div>	
			</question>


			<question [qID]="'3'">
				<div class="text-md-right text-center mb-3 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q3.QUESTION"|translate}}</h1>
					<inner-tooltip [qTitle]="'LOAN_DETAILS.Q3.TOOLTIP_TITLE'|translate"
						[text]="'LOAN_DETAILS.Q3.TOOLTIP_TEXT'|translate" class="m-start-tooltip app-title-small-blue">
					</inner-tooltip>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
					data-toggle="buttons">
					<label class="app-label button-secondary-disabled"
						[ngClass]="{'selected':loanDetails.get('haveOneYet').value==='YES'}" tabindex="0"
						data-id="qID3a" data-fieldName="haveOneYet" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="haveOneYet" value="YES"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled mr-md-3 mt-3 mt-md-0"
						[ngClass]="{'selected':loanDetails.get('haveOneYet').value==='NO'}" tabindex="0" data-id="qID3b"
						data-fieldName="haveOneYet" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="haveOneYet" value="NO"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
				</div>
				<label class="m-error form-text text-center text-md-right"
					*ngIf="loanDetails.get('haveOneYet').hasError('canOverValidator') && submitted" role="alert">
					{{'LOAN_DETAILS.Q3.CAN_OVER' | translate }}
				</label>
			</question>
			<question [qID]="'4'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{'LOAN_DETAILS.Q4.QUESTION'|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
					data-toggle="buttons">
					<label class="app-label button-secondary-disabled"
						[ngClass]="{'selected':loanDetails.get('forThePropertyYouOwn').value==='YES'}" tabindex="0"
						data-id="qID4a" data-fieldName="forThePropertyYouOwn" data-fieldValue="YES">
						{{"LOAN_DETAILS.Q4.A1"|translate}}
						<input class="radio" type="radio" formControlName="forThePropertyYouOwn" value="YES"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled mr-md-3 mt-3 mt-md-0"
						[ngClass]="{'selected':loanDetails.get('forThePropertyYouOwn').value==='NO'}" tabindex="0"
						data-id="qID4b" data-fieldName="forThePropertyYouOwn" data-fieldValue="NO">
						{{"LOAN_DETAILS.Q4.A2"|translate}}
						<input class="radio" type="radio" formControlName="forThePropertyYouOwn" value="NO"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>
			<question [qID]="'5'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q5.QUESTION"|translate}}</h1>
				</div>
				<div class="d-flex text-center text-md-right">
					<inner-tooltip [qTitle]="'LOAN_DETAILS.Q5.TOOLTIP_TITLE'|translate"
						[text]="'LOAN_DETAILS.Q5.TOOLTIP_TEXT'|translate" class="m-start-tooltip app-title-small-blue">
					</inner-tooltip>
				</div>

				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
					data-toggle="buttons">
					<label class="app-label button-secondary-disabled"
						[ngClass]="{'selected':loanDetails.get('doYouIntendToSellIt').value==='YES'}" tabindex="0"
						data-id="qID5a" data-fieldName="doYouIntendToSellIt" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="doYouIntendToSellIt" value="YES"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled mr-md-3 mt-3 mt-md-0"
						[ngClass]="{'selected':loanDetails.get('doYouIntendToSellIt').value==='NO'}" tabindex="0"
						data-id="qID5b" data-fieldName="doYouIntendToSellIt" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="doYouIntendToSellIt" value="NO"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>
			<question [qID]="'6'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"LOAN_DETAILS.Q6.1"|translate}} <br />
						{{"LOAN_DETAILS.Q6.2"|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
					data-toggle="buttons">
					<label class="app-label button-secondary-disabled"
						[ngClass]="{'selected':loanDetails.get('itsMehirLemishtaken').value==='YES'}" tabindex="0"
						data-id="qID6a" data-fieldName="itsMehirLemishtaken" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="itsMehirLemishtaken" value="YES"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled mr-md-3 mt-3 mt-md-0"
						[ngClass]="{'selected':loanDetails.get('itsMehirLemishtaken').value==='NO'}" tabindex="0"
						data-id="qID6b" data-fieldName="itsMehirLemishtaken" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="itsMehirLemishtaken" value="NO"
							(change)="onSubmit(loanDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>
			<question [qID]="'7'">
				<div class="mt-md-0 mt-5">
					<div class="text-md-right text-center">
						<h1>{{"LOAN_DETAILS.Q7.QUESTION"|translate}}</h1>
						<div class="d-flex text-center text-md-right">
							<inner-tooltip [qTitle]="'LOAN_DETAILS.Q7.TOOLTIP_TITLE'|translate"
								[text]="'LOAN_DETAILS.Q7.TOOLTIP_TEXT'|translate"
								class="m-start-tooltip app-title-small-blue"></inner-tooltip>
						</div>

					</div>
					<div
						class="row justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center">
						<div class="col-lg-3 col-md-4 col-sm-6 col-12 input-wrapper">
							<app-animated-input formControlName="propertValue" [maxLength]="14" [type]="'tel'"
								placeholder="{{'LOAN_DETAILS.Q7.PH1'|translate}}" [hasCurrencyMask]="true"
								[animatedLabel]="true" [attAriaLabel]="'LOAN_DETAILS.Q7.PH1'|translate" #propertValue>
							</app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('propertValue').hasError('required') && submitted">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
						<div class="col-lg-3 col-md-4 col-sm-6 col-12 input-wrapper mt-3 mt-md-0">
							<app-animated-input formControlName="apartmentCost" [maxLength]="14" [type]="'tel'"
								placeholder="{{'LOAN_DETAILS.Q7.PH2'|translate}}" [hasCurrencyMask]="true"
								[animatedLabel]="true" [attAriaLabel]="'LOAN_DETAILS.Q2.PH1'|translate" #apartmentCost>
							</app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="loanDetails.get('apartmentCost').hasError('required') && submitted">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>

					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
						*ngIf="loanDetails.get('propertValue').hasError('amountValidator75') && submitted">
						{{'PROPERTY_DETAILS.Q2.ERROR_75' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
						*ngIf="loanDetails.get('propertValue').hasError('amountValidator70') && submitted">
						{{'PROPERTY_DETAILS.Q2.ERROR_70' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
						*ngIf="loanDetails.get('propertValue').hasError('amountValidator50') && submitted">
						{{'PROPERTY_DETAILS.Q2.ERROR_50' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button"
						[ngClass]="{'button-primary': loanDetails.valid, 'button-primary-disabled': !(loanDetails.valid && qID=='7')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

		</questions-manager>
	</div>


// WEBPACK FOOTER //
// ./src/app/loan-details/loan-details.component.html